import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { RegisterForm } from '~/components/RegisterForm';
import Api from '~/api';
import { getEvent } from '~/selectors/event';
const Register = (props) => {
    useEffect(() => {
        Api.Analytics.loadOgrForm();
    }, []);
    return _jsx(RegisterForm, { ...props });
};
const mapStateToProps = (state) => ({
    event: getEvent(state),
});
export default connect(mapStateToProps)(Register);
